import { z } from "zod";

import { tradeInVehicleSchema } from "@/lib/schemas/vehicle-trade-in";
import type { Draft, DraftTradeInVehicle } from "@/prisma/generated/client";

export const saveDraftTradeInVehicleInputSchema = tradeInVehicleSchema.extend({
  id: z.number().int().positive().optional(),
});

export const saveDraftTradeInDataSchema = z.discriminatedUnion("hasTradeIn", [
  z.object({
    id: z.number().int().positive(),
    hasTradeIn: z.literal(false),
  }),
  z.object({
    id: z.number().int().positive(),
    hasTradeIn: z.literal(true),
    tradeInVehicles: z.array(saveDraftTradeInVehicleInputSchema).min(1).max(3),
  }),
]);

export type SaveDraftTradeInDataInput = z.infer<
  typeof saveDraftTradeInDataSchema
>;

export type TradeInAnswer = "" | "yes" | "no";

export type TradeInVehicleFormRow = {
  id?: number;
  brandId: number | null;
  model: string;
};

export type TradeInFormState = {
  answer: TradeInAnswer;
  vehicles: TradeInVehicleFormRow[];
};

const EMPTY_TRADE_IN_FORM_STATE: TradeInFormState = {
  answer: "",
  vehicles: [],
};

export type DraftTradeInFields = Pick<Draft, "hasTradeIn"> & {
  tradeInVehicles?: DraftTradeInVehicle[];
};

export function mapDraftToTradeInFormState(
  draft: DraftTradeInFields | null | undefined,
): TradeInFormState {
  if (draft === null || draft === undefined) {
    return EMPTY_TRADE_IN_FORM_STATE;
  }

  if (draft.hasTradeIn === null || draft.hasTradeIn === undefined) {
    return EMPTY_TRADE_IN_FORM_STATE;
  }

  if (!draft.hasTradeIn) {
    return { answer: "no", vehicles: [] };
  }

  const vehicles = [...(draft.tradeInVehicles ?? [])]
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((vehicle) => ({
      id: vehicle.id,
      brandId: vehicle.brandId,
      model: vehicle.model,
    }));

  if (vehicles.length === 0) {
    return {
      answer: "yes",
      vehicles: [{ brandId: null, model: "" }],
    };
  }

  return { answer: "yes", vehicles };
}
